// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"07f57bb7","82":"e40ac0ab","247":"1465b870","422":"bcad6f0c","627":"0a1c64cc","670":"11c5a278","834":"1f9d936e","867":"a193f4da","923":"c9cc92e4","938":"09db318d"}[chunkId] + ".chunk.js";
};